import React, { FC } from 'react';
import { GenericModal as GenericModalUDL } from './component';
import { GenericModal as GenericModalLegacy } from './component.legacy';
import { GenericModalProps } from './types';
import { convertLegacyModalSize } from '../../utils/legacyModalSize';

const convertButtonProps = buttonConfig => {
  if (buttonConfig.saveAction) {
    buttonConfig.onClick = buttonConfig.saveAction;
  }
  if (!buttonConfig.label) {
    buttonConfig.label = buttonConfig.text || buttonConfig.saveText;
  }
  return buttonConfig;
};

export const GenericModal: FC<GenericModalProps> = props => {
  if (props.renderAsLegacy) {
    return <GenericModalLegacy {...props} />;
  } else {
    return (
      <GenericModalUDL
        {...props}
        size={props.size && convertLegacyModalSize(props.size)}
        footerCloseButton={props.footerCloseButton && convertButtonProps(props.footerCloseButton)}
        saveButtonConfig={props.saveButtonConfig && convertButtonProps(props.saveButtonConfig)}
      />
    );
  }
};
